import AfterSalesLayout from "../aftersaleslayout/AfterSalesLayout";
import FallbackImg from "../../../components/FallbackImg";
import BackBlue from "../../../assets/aftersalesservice_icons/back_blue_icon.svg";
import UserManualMaintIcon from "../../../assets/aftersalesservice_icons/user_manual_maintenance_icon.svg";
import KeepClean from "../../../assets/aftersalesservice_icons/keep_clean_icon.svg";
import KeepClean1 from "../../../assets/aftersalesservice_icons/keep_clean_1_icon.svg";
import KeepClean2 from "../../../assets/aftersalesservice_icons/keep_clean_2_icon.svg";
import KeepClean3 from "../../../assets/aftersalesservice_icons/keep_clean_3_icon.svg";
import KeepClean4 from "../../../assets/aftersalesservice_icons/keep_clean_4_icon.svg";
import BeforeCool from "../../../assets/aftersalesservice_icons/before_cool_icon.svg";
import BeforeCool1 from "../../../assets/aftersalesservice_icons/before_cool_1_icon.svg";
import EndSeason from "../../../assets/aftersalesservice_icons/end_season_icon.svg";
import EndSeason1 from "../../../assets/aftersalesservice_icons/end_season_1_icon.svg";
import SafetyGuide from "../../../assets/aftersalesservice_icons/safety_guide_icon.svg";
import SafetyGuide1 from "../../../assets/aftersalesservice_icons/safety_guide_1_icon.svg";
import WhenRequest from "../../../assets/aftersalesservice_icons/when_request_icon.svg";
import KeepClean4Icon from "../../../assets/aftersalesservice_icons/keep_clean_4_icon.svg";
import { useLanguage } from "../LanguageContext";

const UserManualMaintenance = () => {
  const { trans } = useLanguage();

  return (
    <AfterSalesLayout>
      <div
        className="as-user-manual-maint-content"
        id="user_manual_maintenance_modal"
      >
        <div style={{ padding: "0 31.97px" }}>
          <div className="as-user-manual-maint-container">
            <button
              type="button"
              className="as-back-btn"
              id="user_manual_maintenance_back"
              onClick={() => window.history.back()}
            >
              <FallbackImg src={BackBlue} alt="back_blue_icon" />
              {trans.back_manual}
            </button>

            <div className="as-user-manual-maint-main">
              <FallbackImg
                src={UserManualMaintIcon}
                alt="user_manual_maintenance_icon"
              />
              <div>
                <div className="as-user-manual-maint-main-title">
                  {trans.maint}
                </div>
                <div className="as-user-manual-maint-main-text">
                  {trans.maint_sub_2}
                </div>
              </div>
            </div>
          </div>

          <div className="as-keep-clean-container">
            <div className="as-keep-clean-title">
              <FallbackImg src={KeepClean} alt="keep_clean_icon" />
              <div>{trans.keep_clean}</div>
            </div>

            <div className="as-keep-clean-box as-darkblue">
              <div>{trans.keep_clean_sub_1}</div>
            </div>

            <div className="as-keep-clean-subtitle">
              <FallbackImg src={KeepClean1} alt="keep_clean_1_icon" />
              <div>{trans.keep_clean_subtitle_1}</div>
            </div>
            <div className="as-keep-clean-box as-lightblue">
              <div style={{ color: "#1447E6" }}>{trans.keep_clean_sub_2}</div>
              <div>{trans.keep_clean_sub_3}</div>
              <div className="as-keep-clean-box as-red">
                <div style={{ color: "#C10007", fontSize: 13 }}>
                  <FallbackImg src={KeepClean4} alt="caution_icon" />
                  {trans.keep_clean_sub_4}
                </div>
              </div>
            </div>

            <div className="as-keep-clean-subtitle">
              <FallbackImg src={KeepClean2} alt="keep_clean_2_icon" />
              <div>{trans.keep_clean_subtitle_2}</div>
            </div>
            <div className="as-keep-clean-box as-cyan">
              <FallbackImg src={KeepClean3} alt="keep_clean_3_icon" />
              <div>{trans.keep_clean_sub_5}</div>
            </div>
            <div className="as-keep-clean-box as-red">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.keep_clean_sub_6}</div>
            </div>
          </div>

          <div className="as-before-cool-container">
            <div className="as-before-cool-title">
              <FallbackImg src={BeforeCool} alt="before_cool_icon" />
              <div>{trans.before_cool}</div>
            </div>
            <div className="as-before-cool-subtitle">
              {trans.before_cool_sub_1}
            </div>

            <div className="as-before-cool-box">
              <FallbackImg src={BeforeCool1} alt="before_cool_1_icon" />
              <div>{trans.before_cool_sub_2}</div>
            </div>
            <div className="as-before-cool-box">
              <FallbackImg src={BeforeCool1} alt="before_cool_1_icon" />
              <div>{trans.before_cool_sub_3}</div>
            </div>
            <div className="as-before-cool-box">
              <FallbackImg src={BeforeCool1} alt="before_cool_1_icon" />
              <div>{trans.before_cool_sub_4}</div>
            </div>
            <div className="as-before-cool-box">
              <FallbackImg src={BeforeCool1} alt="before_cool_1_icon" />
              <div>{trans.before_cool_sub_5}</div>
            </div>

            <div style={{ color: "#008236", fontSize: 13 }}>
              {trans.before_cool_sub_6}
            </div>
          </div>

          <div className="as-end-season-container">
            <div className="as-end-season-title">
              <FallbackImg src={EndSeason} alt="end_season_icon" />
              <div>{trans.end_season}</div>
            </div>
            <div className="as-end-season-subtitle">
              {trans.end_season_sub_1}
            </div>

            <div className="as-end-season-box">
              <FallbackImg src={EndSeason1} alt="end_season_1_icon" />
              <div>{trans.end_season_sub_2}</div>
            </div>
            <div className="as-end-season-box">
              <FallbackImg src={EndSeason1} alt="end_season_1_icon" />
              <div>{trans.end_season_sub_3}</div>
            </div>
            <div className="as-end-season-box">
              <FallbackImg src={EndSeason1} alt="end_season_1_icon" />
              <div>{trans.end_season_sub_4}</div>
            </div>
          </div>

          <div className="as-safety-guide-container">
            <div className="as-safety-guide-title">
              <FallbackImg src={SafetyGuide} alt="safety_guide_icon" />
              <div>{trans.safety_guide}</div>
            </div>
            <div className="as-safety-guide-subtitle">
              {trans.safety_guide_sub_1}
            </div>

            <div className="as-safety-guide-box as-yellow">
              <FallbackImg src={SafetyGuide1} alt="safety_guide_1_icon" />
              <div>{trans.safety_guide_sub_2}</div>
            </div>
            <div className="as-safety-guide-box as-yellow">
              <FallbackImg src={SafetyGuide1} alt="safety_guide_1_icon" />
              <div>{trans.safety_guide_sub_3}</div>
            </div>
            <div className="as-safety-guide-box as-yellow">
              <FallbackImg src={SafetyGuide1} alt="safety_guide_1_icon" />
              <div>{trans.safety_guide_sub_4}</div>
            </div>
            <div className="as-safety-guide-box as-red">
              <FallbackImg src={KeepClean4} alt="keep_clean_4_icon" />
              <div>
                <div>{trans.safety_guide_sub_5}</div>
                <div style={{ color: "#C10007" }}>
                  {trans.safety_guide_sub_6}
                </div>
              </div>
            </div>
          </div>

          <div className="as-when-request-container">
            <div className="as-when-request-title">
              <FallbackImg src={WhenRequest} alt="when_request_icon" />
              <div>{trans.when_request}</div>
            </div>
            <div className="as-when-request-subtitle">
              {trans.when_request_sub_1}
            </div>

            <div className="as-when-request-box">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.when_request_sub_2}</div>
            </div>
            <div className="as-when-request-box">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.when_request_sub_3}</div>
            </div>
            <div className="as-when-request-box">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.when_request_sub_4}</div>
            </div>
            <div className="as-when-request-box">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.when_request_sub_5}</div>
            </div>
            <div className="as-when-request-box">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.when_request_sub_6}</div>
            </div>
            <div className="as-when-request-box">
              <FallbackImg src={KeepClean4Icon} alt="keep_clean_4_icon" />
              <div>{trans.when_request_sub_7}</div>
            </div>
          </div>

          <div className="as-regular-maint-container">
            {trans.regular_maint}
          </div>
        </div>
      </div>
    </AfterSalesLayout>
  );
};

export default UserManualMaintenance;
